import EditRequestEnterMetadataComponent from '../../components/EditRequest/components/enter-metadata.component';
import { useNavigate } from 'react-router-dom';
import GoBackButton from '../../components/GoBackButton';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';

const EditRequest = () => {
  const navigate = useNavigate();

  // Generate SEO metadata for edit request page
  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['request/edit'].name,
    dynamicPages['request/edit'].url,
    dynamicPages['request/edit'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      <div className={`w-full flex flex-col items-center bg-white`}>
        <div className="sticky top-[68px] md:top-[80px] px-[17.5px] pt-5 md:pt-10 pb-6 w-full text-center z-10 bg-white">
          <GoBackButton onClick={() => navigate('/article/manage?tab=requests')} />
          <h1 className="text-2xl md:text-[32px] font-[800] mb-1">Edit Request</h1>
          <p className="!text-02-dim-gray">
            Edit a request of the content you need to <br />
            your community
          </p>
        </div>
        <div className="px-[17.5px] w-full md:mb-0 mb-[50px]">
          <EditRequestEnterMetadataComponent />
        </div>
      </div>
    </div>
  );
};

export default EditRequest;
